export default __webpack_public_path__ + "static/media/line-chart.cd1d8b64.png";